import * as React from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

interface LinkProps {
  children: React.ReactChildren | React.ReactNode;
  to: string;
  disabled: boolean;
  active: boolean;
  className?: string;
}

const TxtLink = styled.div<{ children?: any }>`
  color: #999;
`;

export const Link = styled.a<{ children?: any }>`
  color: #666;
  cursor: pointer;
  &:hover {
    color: #333;
  }
  &.active {
    color: red;
  }
`;

const Alink: React.FC<LinkProps> = ({
  children,
  to,
  disabled,
  active,
  className: cname = "",
}) => {
  const history = useHistory();

  const clickHandler = () => {
    history.push(to);
  };

  return disabled ? (
    <TxtLink className={cname}> {children}</TxtLink>
  ) : (
    <Link className={active ? `active ${cname}` : cname} onClick={clickHandler}>
      {children}
    </Link>
  );
};

export default Alink;
